import { apiClient } from 'pobble-components/dist/api'
import { unsetToken } from 'pobble-components/dist/auth-helpers'

export const apiGetMe = params => apiClient.get('v3/me', { params })

export const apiSendAccountDetails = data =>
  apiClient.post('/v3/me/account_details', data)

export const apiLogout = data => {
  return apiClient.post('/v3/logout', data).then(res => {
    unsetToken()
  })
}

export const apiRequestTeacherAccess = data =>
  apiClient.post('/v3/request_teacher_access', data)

export const acceptTC = () =>
  apiClient.post('/v3/me/accept_terms_and_conditions')

export const apiSetRoleInLife = data =>
  apiClient.post(`/v3/me/role_in_life`, data)
